<template>
	<v-flex xs12>
		<v-layout :row="$vuetify.breakpoint.smAndDown" class="messages__header">
			<v-flex xs12 class="documents-display__toolbar">
				<v-toolbar flat dark height="35" color="secondary">
					<v-toolbar-title>{{title}} Message</v-toolbar-title>
					<v-spacer></v-spacer>

					<slot name="sentCheckbox"></slot>

					<badge v-if="badge" :items="messages()"></badge>
				</v-toolbar>
			</v-flex>
			<v-flex xs12 sm6 md3 class="documents-display__sort">
				<v-select
					:items="sort_options"
					placeholder="Sort By"
					height="35"
					hide-details
					class="ma-0"
					solo
					flat
					dense
					:class="!dark ? 'white' : ''"
					:color="dark ? 'tertiary' : ''"
					style="margin: 0; padding: 0"
					@change="sort"
					clearable
				></v-select>
			</v-flex>
		</v-layout>

		<transition-group name="cards" class="layout wrap" tag="div" appear>
			<v-flex xs12 v-for="message in messages(page, perPage)" :key="message.id">
				<message :message="message" :sent="displaySentMessages"></message>
			</v-flex>
		</transition-group>

		<v-layout row wrap class="messages__pagination">
			<v-flex xs12>
				<div class="pagination">
					<v-pagination
						v-model="page"
						:length="pages"
						v-if="messages().length && messages().length > perPage"
					></v-pagination>
				</div>
			</v-flex>
		</v-layout>
	</v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import Badge from "@components/partials/Badge";
import Message from "@views/messages/Message";

export default {
	data() {
		return {
			items: [],
			loading: false,
			page: 1,
			perPage: 5,
			sort_options: [
				{
					text: "Date: Newest to Oldest",
					value: {
						orderby: "created_at",
						order: "desc"
					}
				},
				{
					text: "Date: Oldest to Newest",
					value: {
						orderby: "created_at",
						order: "asc"
					}
				}
			],
			sorting: {
				orderby: "created_at",
				order: "desc"
			}
		};
	},

	props: {
		type: {
			default: "unread",
			type: String
		},

		badge: {
			default: false,
			type: Boolean
		}
	},

	components: { Badge, Message },

	computed: {
		...mapGetters(["dark", "user", "searchQuery"]),

		...mapGetters("messages", {
			GET_MESSAGES: "messages"
		}),

		title() {
			return this.type.charAt(0).toUpperCase() + this.type.slice(1);
		},

		messages() {
			return (page = false) => {
				return this.GET_MESSAGES(
					this.type,
					page,
					this.perPage,
					this.sorting,
					this.searchQuery
				);
			};
		},

		displaySentMessages() {
			return this.type === "sent";
		},

		pages() {
			return Math.ceil(this.messages().length / this.perPage);
		}

		// filters() {

		// 	return {
		// 		sorting: this.sorting
		// 	};
		// }
	},

	methods: {
		sort(params) {
			this.$set(this, "sorting", params);
			// this.filterAndSort(this.filters);
		}

		// filterAndSort(params) {
		// 	let filters = {};

		// 	Object.assign(filters, params);
		// 	this.$set(this, "filterBy", filters);
		// }
	},

	watch: {
		pages() {
			if (this.page > this.pages) {
				this.page = this.pages;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
	.v-toolbar__title {
		text-transform: uppercase;
	}
</style>
